console.log("REPEAT CUSTOM JS LIVE 002");


/* REPEAT ATL — ROW DIVIDERS */
(function () {
  function addRowDividers() {
    if (!document.body.classList.contains("template-collection")) return;

    var productGrid = document.querySelector("collection-grid .grid");
    if (!productGrid) return;

    var oldDividers = productGrid.querySelectorAll(".collection-row-divider");
    Array.prototype.forEach.call(oldDividers, function (el) {
      if (el.parentNode) el.parentNode.removeChild(el);
    });

    var cells = [];
    Array.prototype.forEach.call(productGrid.children, function (child) {
      if (child.querySelector && child.querySelector("product-card")) {
        cells.push(child);
      }
    });

    if (!cells.length) return;

    var cols =
      getComputedStyle(productGrid).gridTemplateColumns.split(" ").filter(Boolean).length || 2;

    cells.forEach(function (cell, i) {
      var isEndOfRow = (i + 1) % cols === 0;
      var isLastItem = i === cells.length - 1;

      if (isEndOfRow && !isLastItem) {
        var divider = document.createElement("div");
        divider.className = "collection-row-divider";
        divider.setAttribute("aria-hidden", "true");
        cell.insertAdjacentElement("afterend", divider);
      }
    });
  }

  window.REPEAT_addRowDividers = addRowDividers;

  function run() {
    requestAnimationFrame(addRowDividers);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }

  window.addEventListener("load", run);
  setTimeout(run, 400);
  setTimeout(run, 1200);
  setTimeout(run, 2500);
})();

/* REPEAT ATL — SOLD OUT BADGE ENFORCER */
(function () {
  function applySoldOutFix(root) {
    root = root || document;

    var badges = root.querySelectorAll(".badge, product-badge");

    Array.prototype.forEach.call(badges, function (badge) {
      if (badge.dataset.repeatProcessed === "true") return;

      var text = (badge.textContent || "").trim().toLowerCase();
      if (text.indexOf("sold out") === -1) return;

      badge.dataset.repeatProcessed = "true";
      badge.classList.add("repeat-soldout-badge");

      var span = badge.querySelector("span");
      if (span) span.classList.add("repeat-soldout-badge__text");
    });
  }

  function run() {
    applySoldOutFix(document);
  }

  run();

  var timeout;
  var observer = new MutationObserver(function () {
    clearTimeout(timeout);
    timeout = setTimeout(run, 120);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

/* REPEAT ATL — MOBILE STICKY FILTER BAR */
(function () {

  function setupStickyFilterBar() {

    if (!document.body.classList.contains("template-collection")) return;

    var bar = document.querySelector(
      ".filter-topbar-container, .repeat-filter-sort-bar"
    );

    if (!bar) return;

    function update() {

      /* desktop reset */
      if (window.innerWidth >= 1024) {

        bar.classList.remove("repeat-mobile-filter-fixed");
        document.body.classList.remove("repeat-mobile-filter-active");
        return;

      }

      /* activate once after scrolling */
      var shouldStick = window.scrollY > 140;

      if (shouldStick) {

        bar.classList.add("repeat-mobile-filter-fixed");
        document.body.classList.add("repeat-mobile-filter-active");

      } else {

        bar.classList.remove("repeat-mobile-filter-fixed");
        document.body.classList.remove("repeat-mobile-filter-active");

      }

    }

    update();

    window.addEventListener("scroll", update, {
      passive: true
    });

    window.addEventListener("resize", update);

  }

  if (document.readyState === "loading") {

    document.addEventListener(
      "DOMContentLoaded",
      setupStickyFilterBar
    );

  } else {

    setupStickyFilterBar();

  }

})();